// src/components/Header.tsx
import { Mail } from 'lucide-react';
import { useAnalytics } from '../hooks/useAnalytics';

const Header = () => {
  const { trackEvent } = useAnalytics();

  const handleEmailClick = () => {
    trackEvent('email_contact_click', {
      location: 'header'
    });
  };

  return (
    <header className="container mx-auto px-6 py-8">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <div className="h-10 w-10 rounded-lg bg-blue-600 flex items-center justify-center">
            <Mail className="h-6 w-6 text-white" />
          </div>
          <span className="text-2xl font-bold text-gray-900">SignoBox</span>
        </div>
        <a 
          href="mailto:support@signobox.com"
          onClick={handleEmailClick}
          className="flex items-center text-gray-600 hover:text-blue-500 transition-colors"
          aria-label="Email us"
        >
          <Mail className="h-6 w-6 mr-2" />
          <span className="hidden sm:inline">Contact Us</span>
        </a>
      </div>
    </header>
  );
};

export default Header;
